<template>
  <span
    v-if="displayCount"
    class="mp-unread"
    :class="sizeClass"
    :title="`${displayCount} unread`"
  >{{ label }}</span>
</template>

<script>
export default {
  name: 'MarketplaceUnreadBadge',

  props: {
    count: {
      type: [Number, String],
      default: 0,
    },
    max: {
      type: Number,
      default: 99,
    },
  },

  computed: {
    displayCount() {
      const n = Number(this.count);
      return Number.isFinite(n) && n > 0 ? n : 0;
    },

    label() {
      if (!this.displayCount) return '';
      return this.displayCount > this.max ? `${this.max}+` : String(this.displayCount);
    },

    sizeClass() {
      const len = String(this.label).length;
      if (len >= 3) return 'mp-unread--lg';
      if (len === 2) return 'mp-unread--md';
      return '';
    },
  },
};
</script>

<style scoped>
.mp-unread {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  margin-left: 6px;
  border-radius: 9px;
  background-color: #e5484d;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  vertical-align: middle;
  box-sizing: border-box;
}

.mp-unread--md {
  min-width: 20px;
}

.mp-unread--lg {
  min-width: 26px;
  border-radius: 10px;
}
</style>
